import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button, Divider, Table, TableHead, TableRow, TableCell, TableBody, Chip, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close";
import OlympiadClubbingPdf from "./modals/OlympiadClubbingPdf";

const ViewOlympiadClubbingModal = ({ closePopup, modalData }) => {

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "completed":
                return "success";

            case "pending":
                return "warning";

            default:
                return "default";
        }
    };

    const handleDownloadPDF = () => {

        OlympiadClubbingPdf(modalData);
    };

    return (
        <Box
            sx={{
                backgroundColor: "#f5f7fb",
                height: "100%",
                overflowY: "auto"
            }}
        >

            {/* HEADER */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#fff",
                    borderBottom: "1px solid #ddd",
                    px: 3,
                    py: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <Box>
                    <Typography variant="h5" fontWeight="bold">
                        Olympiad Details
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        {modalData?.schoolName} ({modalData?.partyId})
                    </Typography>
                </Box>

                <IconButton onClick={closePopup}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box p={3}>

                {/* OVERVIEW */}
                <Grid container spacing={2} mb={3}>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2">
                                    Registrations
                                </Typography>

                                <Typography variant="h5" fontWeight="bold">
                                    {modalData?.totalRegistrations}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2">
                                    Total Amount
                                </Typography>

                                <Typography variant="h5" fontWeight="bold">
                                    ₹ {modalData?.overAllAmount}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2">
                                    Paid
                                </Typography>

                                <Typography
                                    variant="h5"
                                    fontWeight="bold"
                                    color="green"
                                >
                                    ₹ {modalData?.overAllPaid}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2">
                                    Pending
                                </Typography>

                                <Typography
                                    variant="h5"
                                    fontWeight="bold"
                                    color="red"
                                >
                                    ₹ {modalData?.overAllPending}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2">
                                    Students
                                </Typography>

                                <Typography variant="h5" fontWeight="bold">
                                    {modalData?.overAllStudents}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <Card>
                            <CardContent>
                                <Typography variant="body2">
                                    Study Material
                                </Typography>

                                <Typography variant="h5" fontWeight="bold">
                                    {modalData?.overAllStudyMaterial}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                </Grid>

                {/* COORDINATORS */}
                <Card sx={{ mb: 3 }}>
                    <CardContent>

                        <Typography variant="h6" fontWeight="bold" mb={2}>
                            Coordinators
                        </Typography>

                        <Grid container spacing={2}>
                            {modalData?.overAllCordinators?.map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Box
                                        sx={{
                                            border: "1px solid #ddd",
                                            borderRadius: 2,
                                            p: 2
                                        }}
                                    >
                                        <Typography fontWeight="bold">
                                            {item?.name}
                                        </Typography>

                                        <Typography variant="body2">
                                            {item?.subject}
                                        </Typography>

                                        <Typography variant="body2">
                                            {item?.role}
                                        </Typography>

                                        <Typography variant="body2">
                                            {item?.mobile}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>

                    </CardContent>
                </Card>

                {/* REGISTRATIONS */}
                {modalData?.registrations?.map((reg, index) => (

                    <Card key={index} sx={{ mb: 4 }}>
                        <CardContent>

                            {/* REG HEADER */}
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                flexWrap="wrap"
                                mb={2}
                            >
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">
                                        {reg?.rno_id}
                                    </Typography>

                                    <Typography variant="body2">
                                        {reg?.registration_type_name}
                                    </Typography>
                                </Box>

                                <Box display="flex" gap={1} mt={1}>
                                    <Chip
                                        label={reg?.transactionStatus}
                                        color={getStatusColor(reg?.transactionStatus)}
                                    />

                                    <Chip
                                        label={reg?.deliveryStatus}
                                        color={getStatusColor(reg?.deliveryStatus)}
                                    />
                                </Box>
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            {/* BASIC DETAILS */}
                            <Grid container spacing={2} mb={2}>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="body2">
                                        Owner
                                    </Typography>

                                    <Typography fontWeight="bold">
                                        {reg?.ownerName}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="body2">
                                        Mobile
                                    </Typography>

                                    <Typography fontWeight="bold">
                                        {reg?.ownerMobile}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="body2">
                                        Medium
                                    </Typography>

                                    <Typography fontWeight="bold">
                                        {reg?.medium_name}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Typography variant="body2">
                                        Exam Date
                                    </Typography>

                                    <Typography fontWeight="bold">
                                        {formatDate(reg?.exam_date)}
                                    </Typography>
                                </Grid>

                            </Grid>

                            {/* AMOUNT DETAILS */}
                            <Grid container spacing={2} mb={3}>

                                <Grid item xs={12} md={3}>
                                    <Card variant="outlined">
                                        <CardContent>
                                            <Typography variant="body2">
                                                Total Amount
                                            </Typography>

                                            <Typography fontWeight="bold">
                                                ₹ {reg?.totalAmount}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Card variant="outlined">
                                        <CardContent>
                                            <Typography variant="body2">
                                                Paid
                                            </Typography>

                                            <Typography
                                                fontWeight="bold"
                                                color="green"
                                            >
                                                ₹ {reg?.totalPaid}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Card variant="outlined">
                                        <CardContent>
                                            <Typography variant="body2">
                                                Pending
                                            </Typography>

                                            <Typography
                                                fontWeight="bold"
                                                color="red"
                                            >
                                                ₹ {reg?.pendingAmount}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Card variant="outlined">
                                        <CardContent>
                                            <Typography variant="body2">
                                                Students
                                            </Typography>

                                            <Typography fontWeight="bold">
                                                {reg?.TotalStudents}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </Grid>

                            {/* LINE ITEMS */}
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                mb={1}
                            >
                                Subjects & Classes
                            </Typography>

                            <Table size="small" sx={{ mb: 3 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ color: "#fff" }}>Class</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Subject</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Medium</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Students</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Study Material</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Price</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {reg?.allRegistrationLineItemes?.map((item, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{item?.class_name}</TableCell>

                                            <TableCell>{item?.subject_name}</TableCell>

                                            <TableCell>{item?.medium_name}</TableCell>

                                            <TableCell>{item?.student}</TableCell>

                                            <TableCell>{item?.study_material}</TableCell>

                                            <TableCell>
                                                ₹ {item?.subject_price}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            {/* TRANSACTIONS */}
                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                mb={1}
                            >
                                Transactions
                            </Typography>

                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ color: "#fff" }}>Reference</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Payment Mode</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Amount</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Date</TableCell>
                                        <TableCell style={{ color: "#fff" }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {reg?.AllTransactions?.map((txn, i) => (
                                        <TableRow key={i}>
                                            <TableCell>
                                                {txn?.transactionReference}
                                            </TableCell>

                                            <TableCell>
                                                {txn?.payment_mode}
                                            </TableCell>

                                            <TableCell>
                                                ₹ {txn?.paidAmount}
                                            </TableCell>

                                            <TableCell>
                                                {formatDate(txn?.transactionDate)}
                                            </TableCell>

                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={txn?.transactionStatus}
                                                    color={getStatusColor(txn?.transactionStatus)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                        </CardContent>
                    </Card>
                ))}

            </Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={1}
                sx={{
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    p: 2,
                    borderTop: "1px solid #ddd"
                }}
            >

                <Button
                    variant="contained"
                    color="success"
                    startIcon={<DownloadIcon />}
                    onClick={handleDownloadPDF}
                >
                    Download PDF
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={closePopup}
                >
                    Close
                </Button>

            </Box>
        </Box>
    );
};

export default ViewOlympiadClubbingModal;